<core-helpers-box-loading [hidden]="loaded"></core-helpers-box-loading>
<core-helpers-box-http-error *ngIf="loaded && !access" [code]="404" [message]="'Not found'"></core-helpers-box-http-error>

<settings-users-main *ngIf="loaded && access"></settings-users-main>
